<div class="download-status-panel" *ngIf="isVisible()" [class.collapsed]="isCollapsed()">
  <!-- Header -->
  <div class="download-status-header">
    <div class="header-content ">
      <span class="header-title">{{ title() }}</span>
      <div class="header-actions">
        
        <button class="unstyled-btn" (click)="toggleCollapse()">
          <mat-icon>{{ isCollapsed() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        
        <button class="unstyled-btn" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>

      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="download-status-content" *ngIf="!isCollapsed()">
    <div class="files-list">
      <div 
        class="file-item" 
        *ngFor="let file of files(); trackBy: trackByFileId"
        [class.failed]="file.status === 'Failed'"
        [class.completed]="file.status === 'Completed'"
        [class.in-progress]="file.status === 'InProgress'"
      >
        <div class="file-info">
          <div class="file-icon">
            @if (file.status === 'InProgress') {
              <mat-spinner diameter="20"></mat-spinner>
            }
            @if (file.status !== 'InProgress') {
              <mat-icon [class]="getStatusColor(file)">
                {{ getStatusIcon(file) }}
              </mat-icon>
            }
          </div>
          
          <div class="file-details">
            <div class="file-name" [matTooltip]="file.fileName.length > 20 ? file.fileName : ''" matTooltipPosition="above">{{ file.fileName }}</div>
            <div class="file-status">
              <span *ngIf="file.status === 'InProgress'">In Progress...</span>
              <span *ngIf="file.status === 'Completed'">Completed</span>
              <span *ngIf="file.status === 'Failed'">Failed</span>
            </div>
          </div>
        </div>

        <div class="file-actions">
          <!-- Download button for completed files -->
           @if (file.status === 'Completed' && file.downloadUrl) {
            <button class="unstyled-btn" (click)="downloadFile(file)">
              <mat-icon class="download-btn">download</mat-icon>
            </button>
           }
    
          <!-- Remove button for completed/failed files -->
          @if (file.status === 'Completed' || file.status === 'Failed') {
            <button class="unstyled-btn" (click)="removeFile(file.id)">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
    
      </div>
    </div>

    <!-- Summary -->
    <div class="download-summary" *ngIf="files().length > 0">
      <div class="summary-stats">
        <span class="total-files">{{ files().length }} file{{ files().length !== 1 ? 's' : '' }}</span>
        @if (activeCount > 0) {
          <span class="active-downloads">
            • {{ activeCount }} in progress
          </span>
        }
        @if (completedCount > 0) {
          <span class="completed-downloads">
            • {{ completedCount }} completed
          </span>
        }
        @if (failedCount > 0) {
          <span class="failed-downloads">
            • {{ failedCount }} failed
          </span>
        }
      </div>
      @if (files().length > 5) {
        <div class="view-more-btn">
          <span (click)="viewMore()">View More</span>
        </div>
      }
    </div>
  </div>
</div> 